import React from 'react';
import './App.css';
import Index from './Components/Index'
import Studio from './Components/Studio';
import About from './Components/About';
import Cgu from './Components/Cgu';


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";


function App() {
  return (
    <Router>
      <div style={{ backgroundColor:'hsl(147, 100%, 50%)', display:'flex', flexDirection:"column", justifyContent:'center', height:'auto' }}>
        <ul style={{ listStyleType: "none", display:'flex', flexDirection:'row', paddingTop: 15 }}>
          <li>
            <Link className="myLiLogo" to="/"><span style={{color: "rgb(11, 232, 129)" }}>R</span>eact <span style={{color: "rgb(11, 232, 129)" }}>S</span>tudio</Link>
          </li>
          <li>
          <Link className="myLi" to="/about">About me</Link>
          </li>
          <li>
          <Link className="myLi" to="/studio">The Studio</Link>
          </li>
          <li>
          <Link style={{ color:'white', textDecoration:'none', fontSize:"1em", fontWeight:"300", marginRight:30, marginLeft:30, position:'absolute', right:10, backgroundColor:'red', padding:8, borderRadius:6 }} to="/studio">BETA SCHOOL PROJECT</Link>
          </li>
        </ul>

        <Switch>
          <Route path="/studio">
            <Studio />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/cgu">
            <Cgu />
          </Route>
          <Route path="/">
            <Index />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
